module.exports = __webpack_public_path__ + "kaitak-ogp-lp6-220123.e8873fc6f804c772d18b.jpg";